import Vue from 'vue'
import App from './App.vue'
import store from './store'

import api from './api/api'
import my from './utils/my.js'


Vue.config.productionTip = false

Vue.prototype.$api = api;
Vue.prototype.$my=my;

new Vue({
	store,
  render: h => h(App),
}).$mount('#app')
